<template>
  <div>
    <template v-if="requirement.result && !requirement.result.applicable">
      <v-chip class="ml-2" small>
        {{ $t("auditor.minimalRequirementForm.na") }}
      </v-chip>
    </template>

    <template v-else>
      <v-chip class="ml-2" small dark color="green" v-if="requirement.result && requirement.result.result === 'PASS'">
        {{ $t("auditor.minimalRequirementForm.passed") }}
      </v-chip>

      <v-chip class="ml-2" small color="red" v-if="requirement.result && requirement.result.result === 'FAIL'">
        {{ $t("auditor.minimalRequirementForm.failed") }}
      </v-chip>
    </template>

    <v-chip class="ml-2" small v-if="requirement.state === 'EDIT'">
      {{ $t("auditor.minimalRequirementForm.response") }}
    </v-chip>

    <v-chip
      class="ml-2"
      small
      :dark="requirement.state === 'DONE'"
      :color="requirement.state === 'DONE' ? 'green' : ''"
    >
      {{ requirement.state }}
    </v-chip>

    <v-chip class="ml-2" small v-if="requirement.referenced">
      {{ $t("requirement.referenced") }}
    </v-chip>

    <v-chip class="ml-2" small v-if="requirement.userFeedback" color="info">
      {{ $t("requirement.userFeedback") }}
    </v-chip>

    <v-chip class="ml-2" small v-if="requirement.auditorFeedback" color="info">
      {{ $t("requirement.auditorFeedback") }}
    </v-chip>
  </div>
</template>

<script>
export default {
  props: {
    requirement: {
      type: Object,
      required: true,
    },
  },
};
</script>
